module.exports = __webpack_public_path__ + "img/DSC_4836-Edit.2d42dcee.jpg";